export const arrayDifference = <T>(array1: Array<T | undefined>, array2: Array<T | undefined>) => {
  const difference: Array<T | undefined> = [];

  for (let i = 0; i < array1.length; i++) {
    if (!array2.includes(array1[i])) {
      difference.push(array1[i]);
    }
  }

  for (let i = 0; i < array2.length; i++) {
    if (!array1.includes(array2[i])) {
      difference.push(array2[i]);
    }
  }

  return difference;
};

export const intersection = <T>(a: T[], b: T[]) => a.filter((x) => b.includes(x));

export const getElementsNotInSecondArray = <T>(a: T[], b: T[]) => {
  const setOfB = new Set(b);
  return a.filter((x) => !setOfB.has(x));
};

export const isEmptyArray = <T>(arr: ArrayLike<T>) => Array.isArray(arr) && arr.length === 0;

export const getRange = ({ length }: { length: number }) => Array.from({ length }, (_, i) => i);

export const getFirstElements = <T>({ items, limit }: { items: Array<T>; limit: number }) =>
  items.slice(0, Math.max(0, limit));
